import { List, Text, Title } from "@mantine/core";
import type { JSX } from "react";

interface IProps {
    context: {
        what: string;
        count: number;
        candidates: string[];
        probabilities: number[];
        selectedIndices: number[];
        epsilon: number;
    };
}

function BrainstormContext({ context }: IProps): JSX.Element {
    return (
        <>
            <Title order={5}>What</Title>
            <Text>{context.what}</Text>
            <Title order={5}>Epsilon</Title>
            <Text>{context.epsilon}</Text>
            <Title order={5}>Candidates</Title>
            <List>
                {context.candidates.map((c, idx) => (
                    <List.Item key={`${idx}-${c}`}>
                        {c} (p={context.probabilities[idx] ?? 0})
                        {context.selectedIndices.includes(idx) ? " — selected" : ""}
                    </List.Item>
                ))}
            </List>
        </>
    );
}

export default BrainstormContext;

